<script setup lang="ts">
  const localePath = useLocalePath();

  const { t } = useI18n();

  const chatStore = useChatStore();
  const { isAiMode } = storeToRefs(chatStore);

  const viewport = useViewport();
  const textOut = computed(() => (viewport.isLessThan('md') ? t('aiButtonTextOutShort') : t('aiButtonTextOut')));

  const navigate = async () => {
    if (isAiMode.value) navigateTo(localePath('/'));
    else navigateTo(localePath('ai-mode'));
  };
</script>

<template>
  <button
    :class="['ai-button', { 'ai-button--active': isAiMode }]"
    @click.prevent.stop="navigate">
    <span class="ai-button__off-wrapper">
      <span class="ai-button__off-icon" />
      <span class="ai-button__off-text">{{ $t('aiButtonTextIn') }}</span>
    </span>
    <span class="ai-button__on-wrapper">
      <span class="ai-button__on-bg">
        <span class="ai-button__on-text">{{ textOut }}</span>
        <span class="ai-button__on-icon" />
      </span>
    </span>
  </button>
</template>
